import { render, staticRenderFns } from "./FinancialTab.vue?vue&type=template&id=082e63da&scoped=true&"
import script from "./FinancialTab.vue?vue&type=script&lang=js&"
export * from "./FinancialTab.vue?vue&type=script&lang=js&"
import style0 from "./FinancialTab.vue?vue&type=style&index=0&id=082e63da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082e63da",
  null
  
)

export default component.exports